import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';

import MobileHeader from '../../components/MobileHeader/MobileHeader';
import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';

const SignupDone = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired
	},

	nextStep() {
		this.context.history.pushState(null, '/', null);
	},
	render() {
		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='signupSteps'
					title='Done'
					step="done"
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<div className="section-wrap">
						<div className="section-body">
							<div className="profile-img"></div>
							<div className="signup-content">
								<h2>You've completed the registration</h2>
								<p>Now you can start your <br/> free 30 days trial.</p>
							</div>
						</div>
						<div className="section-footer">
							<TouchButton type="button" bsStyle="primary" bsSize="large" block onClick={this.nextStep}>Start free trial</TouchButton>
						</div>
					</div>
				</div>
			</div>

		);
	}
});

export default SignupDone;


/** WEBPACK FOOTER **
 ** ./src/screens/signup/SignupDone.js
 **/